import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

export class MenuCteos extends Component {
  render() {
    return (
      <>
        <div className="area-home">
          <Titulo texto="CT-e OS" urlRetorno="/gestao-empresa" />
          <div className="row sistemas md-center mt-2">
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,  getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
              <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-tomadores">
                  <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo-resize'>
                        Gerenciar Tomadores
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-cte-os">
                  <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo-resize'>
                        Gerenciar CT-e OS
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </Autorizacao>
          </div>         
        </div>
        
      </>
    );
  }
}
export function mapStateToProps(state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuCteos));
